/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import {
  BUTTON_FORMAT_STRONG,
  BUTTON_THEME_PRIMARY,
  ButtonProps,
  DIALOG_SIZE_SM_MD,
  DialogContentProps,
  DialogProps,
} from '@squiz/sds';
import { DialogLauncher } from 'apps/console-core/src/Components/DialogLauncher/DialogLauncher';
import { useDialogStore } from 'dxpConsoleCore-mf/State';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { COMPONENT_SERVICE_STRINGS } from '../../../../Constants/Strings.constants';
import { COMPONENT_SETS_DATA_IDS } from '../../ComponentSets.constants';
import { CreateComponentSetForm } from '../../forms/CreateComponentSetForm';

/**
 * The action to create a new component set.
 */
export const CreateComponentSet = (): JSX.Element => {
  const { t } = useTranslation();

  const labels = {
    createSetButton: t(COMPONENT_SERVICE_STRINGS.createNewSet),
    dialogTitle: t(COMPONENT_SERVICE_STRINGS.createNewComponentSet),
  };

  const buttonProps: ButtonProps = {
    format: BUTTON_FORMAT_STRONG,
    text: labels.createSetButton,
    theme: BUTTON_THEME_PRIMARY,
  };

  const dialogProps: DialogProps = {
    dialogContent: {
      renderContent: (props: DialogContentProps): JSX.Element => {
        return <CreateComponentSetForm {...props} />;
      },
    },
    dialogSize: DIALOG_SIZE_SM_MD,
    heading: labels.dialogTitle,
    showDividers: true,
    stateHandler: useDialogStore,
  };

  return (
    <div className="component-sets__actions" data-id={COMPONENT_SETS_DATA_IDS.createSet}>
      <DialogLauncher buttonProps={buttonProps} dialogProps={dialogProps} />
    </div>
  );
};
